import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			position: 'relative',
			padding: ({ isMobile }) => (isMobile ? theme.spacing(4) : theme.spacing(4, 8)),
		},

		background: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			maxWidth: '100%',
			overflow: 'hidden',
			backgroundPositionY: ({ metaData }) => metaData.backgroundImagePosition?.metaValue,
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			transition: theme.transitions.create('border-radius'),
			borderRadius: ({ metaData, isMobile }) => {
				if (isMobile) return null

				const rounding = metaData.backgroundRounding?.toNumber()

				return rounding ? `${rounding}px` : null
			},

			'&:after': {
				content: '""',
				transition: theme.transitions.create('opacity'),
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: ({ metaData }) => metaData.opacity?.toNumber() / 100,
			},
		},
		grid: {
			zIndex: 1,
		},
		buttonWrap: {
			width: '100%',
			display: 'flex',
			justifyContent: 'flex-start',

			[theme.breakpoints.down('xs')]: {
				justifyContent: ({ metaData }) => metaData.mobileAlignment?.contentAlignment(),
			},
		},
		button: {
			width: 'auto',

			[theme.breakpoints.down('xs')]: {
				width: ({ metaData }) => (metaData.mobileButtonWidth?.isWide ? '100%' : 'auto'),
			},
		},
		modal: {
			backgroundColor: 'transparent',
			boxShadow: 'none',
			width: '100%',
			overflowY: 'visible',
		},
		withVideo: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			cursor: 'pointer',
		},
		icon: {
			fontSize: theme.spacing(16.4),
			color: '#fff',
			opacity: 0.45,
		},
		wrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			minHeight: 'auto',
			padding: 0,
			margin: 0,

			[theme.breakpoints.up('md')]: {
				minHeight: theme.spacing(60),
			},
		},

		text: {
			marginBottom: theme.spacing(5.8),

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
				},
			},
		},
	}),
	{ name: 'Banners-Banner14' },
)

export default useStyles
